<script setup>
// Pick one item from a short list (search results, choices) — bordered
// rows with a check on the selected one, like a shadcn RadioGroup card.
const props = defineProps({
  items: { type: Array, default: () => [] },
  itemTitle: { type: String, default: 'name' },
  itemSubtitle: { type: String, default: '' },
  itemValue: { type: String, default: 'id' },
});
const selected = defineModel({ type: [String, Number], default: null });

const valueOf = (item) => item[props.itemValue];
</script>

<template>
  <div class="ui-options" role="radiogroup">
    <button
      v-for="item in items"
      :key="valueOf(item)"
      type="button"
      role="radio"
      class="ui-options__item"
      :class="{ 'ui-options__item--selected': valueOf(item) === selected }"
      :aria-checked="valueOf(item) === selected"
      @click="selected = valueOf(item)"
    >
      <span class="ui-options__text">
        <span class="ui-options__title">{{ item[itemTitle] }}</span>
        <span v-if="itemSubtitle && item[itemSubtitle]" class="ui-options__subtitle">
          {{ item[itemSubtitle] }}
        </span>
      </span>
      <v-icon v-if="valueOf(item) === selected" size="18" class="ui-options__check">
        mdi-check-circle
      </v-icon>
    </button>
  </div>
</template>

<style scoped>
.ui-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ui-options__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: transparent;
  color: var(--foreground);
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.ui-options__item:hover {
  background-color: var(--accent);
}
.ui-options__item:focus-visible {
  outline: 2px solid var(--brand);
  outline-offset: 1px;
}
.ui-options__item--selected {
  border-color: rgb(var(--v-theme-primary));
  background-color: rgba(var(--v-theme-primary), 0.06);
}
.ui-options__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.ui-options__title {
  font-size: 14px;
  font-weight: 500;
}
.ui-options__subtitle {
  font-size: 12px;
  color: var(--muted-foreground);
}
.ui-options__check {
  color: rgb(var(--v-theme-primary));
}
</style>
